import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { City, Voucher } from 'src/app/classes';

@Component({
  selector: 'app-voucher-detail',
  templateUrl: './voucher-detail.component.html',
  styleUrls: ['./voucher-detail.component.scss'],
})
export class VoucherDetailComponent implements OnInit {

  @Input('voucher')
  public voucher: Voucher;

  @Input('closeEvent')
  public closeEvent: EventEmitter<any>;

  @Input('cities')
  public cities: City[];

  @Output('deleteEvent')
  public deleteEvent: EventEmitter<Voucher> = new EventEmitter<Voucher>();

  constructor(private readonly translate: TranslateService) { }

  ngOnInit() { }

  deleteVoucher() {
    this.deleteEvent.emit(this.voucher);
    this.close();
  }

  close() {
    if (this.closeEvent) {
      this.closeEvent.emit();
    }
  }

  getCity(cityId: number | null): string {
    return this.cities.find(x => x.id == cityId) ? this.cities.find(x => x.id == cityId).name : this.translate.instant('allCities');
  }

}
